/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 public/models/cat.glb 
*/

import React from 'react'
import { useModel } from './hooks/useModel'

export function Cat(props) {
  const { nodes } = useModel('/models/cat.glb')

  return (
    <group {...props} dispose={null}>
      <mesh geometry={nodes.Eyes.geometry} castShadow receiveShadow>
        <meshStandardNodeMaterial color="white" roughness={0.9} metalness={0} />
      </mesh>
    </group>
  )
}

